var map = {
	"./basketball-active.webp": 1536,
	"./basketball.webp": 1537,
	"./bg.webp": 1538,
	"./football-active.webp": 1539,
	"./football.webp": 1540,
	"./games-active.webp": 1541,
	"./games.webp": 1542,
	"./live-streaming-cover.webp": 1543,
	"./lv-active-bg.webp": 1544,
	"./video-bg.webp": 1545,
	"./video-icon.webp": 1546,
	"./vs.webp": 1547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;